import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-boletos',
  templateUrl: './boletos.component.html',
  styleUrls: ['./boletos.component.scss']
})
export class BoletosComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/boletos/boletos.component.ts